import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import { Container, createMuiTheme, Toolbar, Typography, CssBaseline, Avatar, Grid, AppBar } from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MaterialTable from 'material-table';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import moment from 'moment';
import styles from "../../jss/material-dashboard-react/views/dashboardStyle.js";
import { ConvertToCurrentTimeZone, ConvertTimeZoneOffset } from '../header/timeFormatter';
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext';
import { Context } from "../contexts/siteContext";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

const useStyles = makeStyles(styles);

export default function StaffingList(props) {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const { theme } = useContext(Theme);
    const { defaultSite, siteLoading } = useContext(Context);
    const [loading, setLoading] = useState(true);
    const [staffingDetails, setStaffingDetails] = useState([]);
    const date = ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite);
    const currentTheme = createMuiTheme(GlobalTheme[theme]);
    const tableHeight = window.innerHeight - 250;
    const data = [];

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const [activeCheck, setActiveCheck] = React.useState(
        { name: 'Active', checked: false, count: 0 }
    );

    const [onBreakCheck, setOnBreakCheck] = React.useState(
        { name: 'On Break', checked: false, count: 0 }
    );

    const [staffings, setStaffings] = useState({
        columns: [
            {
                title: '',
                field: 'StatusImage',
                render: rowData => (
                    (rowData.Status === 'Active') ? <Avatar style={{ width: '16px', height: '16px', borderradius: '50%', backgroundColor: 'green' }}>&nbsp;</Avatar> : <Avatar style={{ width: '16px', height: '16px', borderradius: '50%', backgroundColor: 'red' }}>&nbsp;</Avatar>
                ),
                filtering: false
            },
            { title: 'Name', field: 'Name' },
            { title: 'Start', field: 'Start' },
            { title: 'Duration', field: 'Duration' },
            { title: 'Status', field: 'Status' }
        ],
        data: []
    });

    const getStaffings = () => {
        HttpService.post('/Staffing/GetStaffingDetails', {
            houseCode: defaultSite.houseCode[0],
            siteId: defaultSite.id + "",
            workDate: date
        })
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "StaffingDetails");
                result = offlineResult.OfflineData;
            }
            else if (result && result.error) {
                return;
            }

            let useEpay = result.useEpay;
            let staffingDetailsTemp = [];
            let staffingsTemp = [];
            let active = 0;
            let onBreak = 0;

            if (useEpay) {
                staffingDetailsTemp = result.data;
            }
            else {
                staffingDetailsTemp = JSON.parse(result.data).data;
            }

            if (useEpay) {
                staffingDetailsTemp.forEach((item, index) => {
                    item.Start = item.Start ? moment(item.Start).format('MM/DD/YYYY  hh:mm A') : '';
                    staffingsTemp.push(item);
                });
            }
            else {
                staffingDetailsTemp.forEach((item) => {
                    if (!item.at_work && !item.at_break && !item.at_meal_break) {
                        item.Status = "";
                    }
                    else if (item.at_work && !item.at_break && !item.at_meal_break) {
                        item.Status = "Active";
                        active++;
                    }
                    else {
                        //(item.at_work && !item.at_break && item.at_meal_break) || (item.at_work && item.at_break && !item.at_meal_break)
                        item.Status = "On Break";
                        onBreak++;
                    }

                    item.Name = item.emp_lastname + ", " + item.emp_firstname;

                    //start time and Duration
                    var pLength = item.punches.length;
                    if (pLength > 0) {
                        item.StartTime = item.punches[0].punch_time;
                        item.punches.forEach((subItem) => {
                            if (moment(subItem.punch_time) > moment(item.StartTime)) {
                                item.StartTime = subItem.punch_time;
                            }
                        });
                        item.Start = moment(item.StartTime).format('MM/DD/YYYY  hh:mm A');
                        var diff = moment(ConvertToCurrentTimeZone(new Date(), null, null, defaultSite)).diff(item.StartTime);
                        var duration = moment.duration(diff);
                        if (duration.days() > 0) {
                            item.Duration = duration.days() + "d " + formatTime(duration.hours()) + ":" + formatTime(duration.minutes());
                        }
                        else {
                            item.Duration = formatTime(duration.hours()) + ":" + formatTime(duration.minutes());
                        }
                    }
                    else {
                        item.Start = "";
                        item.Duration = "";
                    }

                    if (item.Status) {
                        staffingsTemp.push(item);
                    }
                });
            }

            setActiveCheck({ ...activeCheck, count: active });
            setOnBreakCheck({ ...onBreakCheck, count: onBreak });
            setStaffingDetails(staffingsTemp);

            setStaffings(prevState => {
                let data = [...prevState.data];
                data = data.concat(staffingsTemp);
                return { ...prevState, data };
            });

            setLoading(false);
        },
        (error) => {
            console.log(error);
        });

        return data;
    }

    const formatTime = (t) => {
        if (t < 10) {
            return "0" + t;
        }
        return t;
    };

    const statusChange = (event) => {
        if (event.target.name === "Active") {
            setActiveCheck({ ...activeCheck, checked: event.target.checked });
        }
        else {
            setOnBreakCheck({ ...onBreakCheck, checked: event.target.checked });
        }
    };

    const filterStatus = () => {
        let list = [];
        if (!activeCheck.checked && !onBreakCheck.checked) {
            list = staffingDetails;
        }
        else {
            staffingDetails.forEach((item) => {
                if ((activeCheck.checked && item.Status === "Active") || (onBreakCheck.checked && item.Status === "On Break")) {
                    list.push(item);
                }
            });
        }

        setStaffings({ ...staffings, data: list });
    };

    useEffect(() => {
        if (siteLoading === false)
            getStaffings();
        // eslint-disable-next-line
    }, [date]);

    useEffect(() => {
        filterStatus();
        // eslint-disable-next-line
    }, [activeCheck, onBreakCheck]);

    return (
        <>
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Container maxWidth="xl" style={{ height: "95%" }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <Link to="/"><KeyboardBackspaceIcon /></Link>
                                <Typography variant="h6" className={classes.title}>&nbsp;Staffing</Typography><StatusIcon />
                                <Grid container justify="flex-end" spacing={2}>
                                    <SmallMenu moduleName={"Staffing"} modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={<Checkbox checked={activeCheck.checked} onChange={statusChange} name={activeCheck.name} />}
                                        label={activeCheck.name + "(" + activeCheck.count + ")"}
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={onBreakCheck.checked} onChange={statusChange} name={onBreakCheck.name} />}
                                        label={onBreakCheck.name + "(" + onBreakCheck.count + ")"}
                                    />
                                </FormGroup>
                                <MaterialTable
                                    title={""}
                                    isLoading={loading}
                                    columns={staffings.columns}
                                    data={staffings.data}
                                    style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                                    options={{
                                        paging: false,
                                        minBodyHeight: tableHeight,
                                        maxBodyHeight: tableHeight,
                                        rowStyle: rowStyle,
                                        headerStyle: {
                                            fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                        }
                                    }}
                                />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        </>
    );
}
